import React, { useState } from 'react';
import { db } from './firebase.js';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; // 👈 import SweetAlert2
import './Iscrizione.css';

export default function Iscrizione() {
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    luogoNascita: '',
    dataNascita: '',
    tipoDocumento: '',
    numeroDocumento: '',
    telefono: '',
    dipartimento: '',
    corsoDiLaurea: '',
    livello: '',
    matricola: '',
    email: '',
    cellulare: ''
  });

  const navigate = useNavigate();

  // mappa dipartimento -> corsi
  const corsiPerDipartimento = {
    demm: ["Giurisprudenza", "Economia Aziendale", "Economia Bancaria e Finanziaria","Statistica"],
    ding: ["Ingegneria Energetica", "Ingegneria Informatica", "Ingegneria Civile", "Ingegneria Biomedica"],
    dst:  ["Biotecnologie","Geologia","Scienze Biologiche","Scienze Motorie"],
  };

  // ordine preciso dei campi
  const campiOrdinati = [
    "nome",
    "cognome",
    "luogoNascita",
    "dataNascita",
    "tipoDocumento",
    "numeroDocumento",
    "dipartimento",
    "corsoDiLaurea",
    "livello",
    "matricola",
    "email",
    "cellulare"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "dipartimento") {
      setFormData(prev => ({
        ...prev,
        dipartimento: value,
        corsoDiLaurea: "" // resetto corso se cambia dipartimento
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.matricola.length !== 9) {
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: "La matricola deve essere di 9 cifre."
      });
      return;
    }
    try {
      await addDoc(collection(db, "iscrizioni"), {
        ...formData,
        timestamp: new Date()
      });

      // Pop-up SweetAlert2
      await Swal.fire({
        title: "Iscrizione completata!",
        html: `
          <p>Passa in una delle nostre sedi:</p>
          <ul style="text-align:left;">
            <li><b>Cubo</b></li>
            <li><b>Via delle Puglie</b></li>
            <li><b>Sant’Agostino</b></li>
          </ul>
          <p>per ritirare la tua tessera associativa.<br/>
          Con la tessera potrai accedere a tutti gli sconti, consultabili sul nostro sito ufficiale.</p>
        `,
        icon: "success",
        confirmButtonText: "Ho capito"
      });

      navigate("/");
    } catch (error) {
      console.error("Errore durante l'iscrizione:", error);
      Swal.fire({
        icon: "error",
        title: "Errore",
        text: "Si è verificato un errore durante l'iscrizione. Riprova più tardi."
      });
    }
  };

  return (
    <div className="form-container">
      <h2>Modulo di Iscrizione</h2>
      <form onSubmit={handleSubmit} className="form">
        {campiOrdinati.map(key => {
          if (key === "tipoDocumento") {
            return (
              <select
                key={key}
                name="tipoDocumento"
                value={formData.tipoDocumento}
                onChange={handleChange}
                required
              >
                <option value="">Seleziona documento</option>
                <option value="patente">Patente</option>
                <option value="carta di identità">Carta di identità</option>
              </select>
            );
          } else if (key === "dipartimento") {
            return (
              <select
                key={key}
                name="dipartimento"
                value={formData.dipartimento}
                onChange={handleChange}
                required
              >
                <option value="">Seleziona dipartimento</option>
                <option value="demm">DEMM</option>
                <option value="dst">DST</option>
                <option value="ding">DING</option>
              </select>
            );
          } else if (key === "corsoDiLaurea") {
            return (
              <select
                key={key}
                name="corsoDiLaurea"
                value={formData.corsoDiLaurea}
                onChange={handleChange}
                required
                disabled={!formData.dipartimento}
              >
                <option value="">Seleziona corso di laurea</option>
                {formData.dipartimento &&
                  corsiPerDipartimento[formData.dipartimento].map(corso => (
                    <option key={corso} value={corso}>{corso}</option>
                  ))
                }
              </select>
            );
          } else if (key === "livello") {
            return (
              <select
                key={key}
                name="livello"
                value={formData.livello}
                onChange={handleChange}
                required
              >
                <option value="">Seleziona livello</option>
                <option value="triennale">Triennale</option>
                <option value="magistrale">Magistrale</option>
                <option value="ciclo unico">Ciclo Unico</option>
              </select>
            );
          } else {
            return (
              <input
                key={key}
                type="text"
                name={key}
                placeholder={key.charAt(0).toUpperCase() + key.slice(1)}
                value={formData[key]}
                onChange={handleChange}
                required
              />
            );
          }
        })}
        <button type="submit">Invia Iscrizione</button>
      </form>
    </div>
  );
}
